import styled from "styled-components";

export const NavLinks = styled.div`
display: flex;
flex-direction: column;
// background-color: pink;
align-items: center;
margin-top: 30px;
width: 100vw;

@media (max-width: 768px){
margin-top: 10px;
}
`;
export const NavigationWrapper = styled.div`
display: flex;
flex-wrap: wrap;
justify-content: space-around;
align-items: center;
// background-color: brown;
border: 1px solid #0E8FD8;
width: 50%;
align-self: center;
border-radius: 4px;
padding-top: 10px;
padding-bottom: 10px;

@media (max-width: 768px){
    gap: 10px;
    width: 60%;
    // background-color: #056988;
    border: none;
    padding-top: 5px;
    padding-bottom: 5px;
}
@media (max-width: 600px){
    width: 90%;
}
@media (max-width: 425px){
    width: 90%;
}
`;
export const MyWish1 = styled.div`
background-color: #0E8FD8;
border: 1px solid #0E8FD8;
height: 30px;
display: flex;
justify-content: center;
align-items: center;
border-radius: 4px;
cursor: pointer;

:hover{
    background-color: #04507B;
    transition: transform 0.5s ease-in;
    border: 1px solid #ffffff;
    transform: scale(0.9);
}

@media (max-width: 768px){
    margin-bottom: 8px;
}
@media (max-width: 600px){
    margin-bottom: 8px;
}
@media (max-width: 425px){
    margin-bottom: 8px;
}
`;
export const Text1 = styled.div`
// background-color: green;
padding-left: 20px;
padding-right: 20px;
padding-top: 10px;
padding-bottom: 10px;
border-radius: 4px;
text-transform: capitalize;
color: #ffffff;
font-size: 12px;

@media (max-width: 600px){
    width: 80vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
@media (max-width: 425px){
    width: 80vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
`;
export const YourWish1 = styled.div`
background-color: #0E8FD8;
border: none;
height: 30px;
display: flex;
justify-content: center;
align-items: center;
border-radius: 4px;
cursor: pointer;

:hover{
    background-color: #04507B;
    transition: transform 0.5s ease-in;
    border: 1px solid #ffffff;
    transform: scale(0.9);
    margin-bottom: 5px;
}
@media (max-width: 768px){
    margin-bottom: 8px;
}
@media (max-width: 600px){
    margin-bottom: 8px;
}
@media (max-width: 425px){
    margin-bottom: 8px;
}
`;
export const Text2 = styled.div`
padding-left: 20px;
padding-right: 20px;
padding-top: 10px;
padding-bottom: 10px;
border-radius: 4px;
text-transform: capitalize;
color: #ffffff;
font-size: 12px;

@media (max-width: 600px){
    width: 80vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
@media (max-width: 425px){
    width: 80vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
`;
export const BuyMePizza = styled.div`
background-color: #D80E0E;
border: none;
height: 30px;
display: flex;
justify-content: center;
align-items: center;
border-radius: 4px;
cursor: pointer;

:hover{
    background-color: #760707;
    transition: transform 0.5s ease-in;
    border: 1px solid #ffffff;
    transform: scale(0.9);
}
@media (max-width: 768px){
    margin-bottom: 8px;
}
@media (max-width: 600px){
    margin-bottom: 8px;
}
@media (max-width: 425px){
    margin-bottom: 8px;
}
`;
export const Text3 = styled.div`
padding-left: 20px;
padding-right: 20px;
padding-top: 10px;
padding-bottom: 10px;
border-radius: 4px;
text-transform: capitalize;
color: #ffffff;
font-weight: 700;

@media (max-width: 600px){
    width: 80vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
@media (max-width: 425px){
    width: 80vw;
    display: flex;
    justify-content: center;
    align-items: center;
}
`;
export const NavigationContent = styled.div`
display: flex;
justify-content: center;
width: 100vw;
`;
// export const NavigationWrapper = styled.div``;
// export const NavigationWrapper = styled.div``;